import React, {useContext, useEffect, useState, useRef} from "react";
import {Form, Input, InputNumber, Tree, Row, Col, Select, Divider, Checkbox} from "antd";
import './main.css';
import {BrandContext} from "@context/BrandContext";
import {ContentContext} from "@context/ContentContext";
import {UserContext} from "@context/UserContext";
import axios from "@common/axios";
import Button from "@common/Button"
import Tab from "@common/Tab";
import Tabs from "@common/Tabs";
import CircularLoader from "@common/CircularLoader";
import HelpIcon from "@mui/icons-material/Help";
import Tooltip from "@common/Tooltip";
import MathJaxHTMLContent from "@common/MathJaxHTMLContent";
const PreTest = (props) => {
    const defaultQuestionAmount = 20,
        MIN_QUESTIONS = 4,
        TREE_BASE_HEIGHT = 500,
        TREE_MAX_HEIGHT = 742,
        [ratioVal, setRatioVal] = useState('MOSTLY_EASY_SOME_MEDIUM'),
        [updateDetailsForm] = Form.useForm(),
        TABS = {TEXT: {val: '0', description: 'Textbook'}, CURRICULUM: {val: '1', description: 'Curriculum'}},
        [tabVal, setTabVal] = useState(TABS.TEXT.val),
        brandConfig = useContext(BrandContext),
        {user} = useContext(UserContext),
        {content} = useContext(ContentContext),
        [testName, setTestName] = useState(props.editTest.name),
        [description, setDescription] = useState(props.editTest.description ? props.editTest.description : ''),
        [treeMaxHeight, setTreeMaxHeight] = useState(TREE_BASE_HEIGHT),
        [curriculumSyllabus, setCurriculumSyllabus] = useState({}),
        [questionAmount, setQuestionAmount] = useState(defaultQuestionAmount),
        [selectedTextSkillIds, setSelectedTextSkillIds] = useState([]),
        [selectedCurriculumSkillIds, setSelectedCurriculumSkillIds] = useState([]),
        [selectedTextSkillsMap, setSelectedTextSkillsMap] = useState({}),
        [selectedCurriculumSkillsMap, setSelectedCurriculumSkillsMap] = useState({}),
        [textTreeDefaultExpandedKeys, setTextTreeDefaultExpandedKeys] = useState([]),
        [selectedTextKeys, setSelectedTextKeys] = useState([]),
        [selectedCurriculumKeys, setSelectedCurriculumKeys] = useState([]),
        [treeTextSelectData, setTreeTextSelectData] = useState([]),
        [treeCurriculumSelectData, setTreeCurriculumSelectData] = useState([]),
        [questionRatioTypes, setQuestionRatioTypes] = useState(null),
        QUESTIONS_TOOLTIP = <div className='ch-center-tooltip'>
            <div>This Wizard is designed to provide optimal coverage of Mathematical Skills for a test based on:</div>
            <div>the selection of Skills, the amount of test questions specified, and the ratio of question difficulty.</div>
            <div>It works by using a balancing matrix to select questions based on these inputs to maximise even coverage across the requested Skills.</div>
        </div>;

    useEffect(() => {
        const syllabus = content.currentSyllabus;
        const treeSyllabus = [{
            selectable: false,
            checkable: false,
            label: syllabus.syllabusName,
            title: syllabus.syllabusName,
            key: String(syllabus.syllabusId),
            value: String(syllabus.syllabusId),
            children: content.topicsList.map(topic =>{
                return {
                    selectable: false,
                    checkable: false,
                    label: topic.topicName,
                    title: topic.topicName,
                    key: syllabus.syllabusId+'-'+topic.topicId,
                    value: syllabus.syllabusId+'-'+topic.topicId,
                    isLeaf: false,
                    topicId: topic.topicId
                }
            })
        }];

        setTextTreeDefaultExpandedKeys([String(syllabus.syllabusId)]);
        setTreeTextSelectData(treeSyllabus);

        axios.get('/web/ui/nav/getSyllabusLink',{params: {syllabusId:syllabus.syllabusId}})
            .then(response => {
                if(response.data){
                    setCurriculumSyllabus(response.data);
                }else{
                    setCurriculumSyllabus({});
                }
            }).catch(error=>{
                console.error('Error loading syllabus link. ', error);
        });


        axios.get('/web/ui/test/getQuestionRatioType')
            .then(response => {
                // console.log('response.data: ',response.data);
                const ratioTypes = {};
                if(response.data){
                    response.data.map((ratioType)=>{
                        ratioTypes[ratioType] = ratioType;
                    });
                    // console.log('ratioTypes: ',ratioTypes);
                    setQuestionRatioTypes(ratioTypes);
                }
            }).catch((error)=>{
            console.error('Error updating test group: ', error);
        });

    },[]);

    useEffect(()=>{
        if(Object.keys(curriculumSyllabus).length > 0) {
            axios.get('/web/ui/nav/syllabus/' + curriculumSyllabus.syllabusId + '/topicGroups')
                .then((response) => {
                    const curricTopicGroups = [];
                    if (response.data) {
                        response.data.map((topicGroup) => {
                            let topicGroupObj = {
                                selectable: false,
                                checkable: false,
                                label: topicGroup.topicGroupName,
                                title: topicGroup.topicGroupName,
                                key: curriculumSyllabus.syllabusId + '-' + topicGroup.topicGroupId,
                                value: curriculumSyllabus.syllabusId + '-' + topicGroup.topicGroupId,
                                children: topicGroup.topics.map(topic => {
                                    return {
                                        selectable: false,
                                        checkable: false,
                                        label: topic.topicName,
                                        title: topic.topicName,
                                        key: curriculumSyllabus.syllabusId + '-' + topicGroup.topicGroupId + '-' + topic.topicId,
                                        value: curriculumSyllabus.syllabusId + '-' + topicGroup.topicGroupId + '-' + topic.topicId,
                                        isLeaf: false,
                                        topicId: topic.topicId
                                    }
                                })
                            }
                            curricTopicGroups.push(topicGroupObj);
                        });
                        setTreeCurriculumSelectData(curricTopicGroups);
                    }
                }).catch((error) => {
                console.error('Error getting topic groups for curriculum syllabus: ', error);
            })
        }
    }, [curriculumSyllabus]);

    // useEffect(() => {
    //     let tempTreeMaxHeight = TREE_BASE_HEIGHT,
    //         treeMaxHeight = TREE_MAX_HEIGHT;
    //
    //     if (description.trim() === '') {
    //         tempTreeMaxHeight += 38;
    //         treeMaxHeight += 38;
    //     }
    //
    //     tempTreeMaxHeight += (selectedTextKeys.length * 22);
    //
    //     if (tempTreeMaxHeight > treeMaxHeight) {
    //         tempTreeMaxHeight = treeMaxHeight;
    //     }
    //
    //     setTreeMaxHeight(tempTreeMaxHeight);
    // }, [description, selectedTextKeys]);

    const generatePreTest = () => {
        let selectedSkillsMap,
            selectedSkillIds;
        if (tabVal === TABS.TEXT.val) {
            selectedSkillIds = selectedTextSkillIds;
            selectedSkillsMap = selectedTextSkillsMap;
        } else {
            selectedSkillIds = selectedCurriculumSkillIds;
            selectedSkillsMap = selectedCurriculumSkillsMap;
        }

        if (!testName || !props.editTest.testId || Object.entries(selectedSkillsMap).length === 0 || Object.entries(selectedSkillsMap).length > questionAmount) {
            return;
        }

        let conceptIds = [];
        Object.entries(selectedSkillsMap).map(([conceptId, skills], index) => {
            if (skills.length == 0) conceptIds.push(conceptId);
        });

        axios.post('/web/ui/test/generateDiagnosticTestFromWizard', null, {
            params: {
                testName: testName,
                testId: props.editTest.testId,
                description: description ? description : '',
                skillIds: selectedSkillIds.toString(),
                conceptIds: conceptIds.toString(),
                questionAmount: questionAmount,
                questionRatio: ratioVal
            }
        })
            .then((response) => {
                if (response.data) {
                    props.setShowEditWizard(false);
                }
            }).catch(error => {
            console.error('Error getting questions types:', error)
        });
    }

    // { key, children }
    const loadData = (data) =>
        new Promise((resolve) => {
            // console.log('data: ',data);
            let key = data.key,
                children = data.children;

            if (children) {
                resolve();
                return;
            }
            // console.log('treeSelectData: ',treeSelectData[0].children);
            const treeSelectData = TABS.TEXT.val === tabVal ? treeTextSelectData : treeCurriculumSelectData;

            if(data.hasOwnProperty('conceptId')) {
                let topic,
                    concept = null;
                for (let t = 0; t < treeSelectData.length; t++) {
                    for (let i = 0; i < treeSelectData[t].children.length; i++) {
                        const child = treeSelectData[t].children[i];
                        if (data.topicId === child.topicId) {
                            topic = child;
                            break;
                        }
                    }
                }

                if (topic === null) {
                    resolve();
                    console.error('Error loading concepts for topic in wizard tree');
                    return;
                }

                for (let i = 0; i < topic.children.length; i++) {
                    const child = topic.children[i];
                    if(child.key === data.key){
                        concept = child;
                    }
                }

                if(concept === null){
                    resolve();
                    console.error('Error loading skills for concept in wizard tree');
                    return;
                }

                axios.get('/web/ui/test/getSkillsForConcept', {params:{conceptId:concept.conceptId, hasQuestions:true}})
                    .then((response)=>{
                        if(response.data){
                            // console.log('response.data: ',response.data);
                            const skills = [];
                            response.data.map( skill =>{
                                skills.push(
                                    {
                                        key: key + '-' + skill.skillId,
                                        selectable: false,
                                        checkable: true,
                                        value: key + '-' + skill.skillId,
                                        conceptId: concept.conceptId,
                                        skillId: skill.skillId,
                                        label: skill.name,
                                        title: skill.name,
                                        conceptName: concept.label,
                                        isLeaf: true
                                    }
                                );
                            });
                            concept.children = skills;
                            const updateData = [...treeSelectData];
                            if(TABS.TEXT.val === tabVal){
                                setTreeTextSelectData(updateData);
                            }else{
                                setTreeCurriculumSelectData(updateData);
                            }
                            // console.log('updateData: ',updateData);
                            resolve();
                        }
                    }).catch((error)=>{
                    resolve();
                    console.error('Error loading skills for concept in tree: ',error);
                });
            } else if(data.hasOwnProperty('topicId')) {
                let topic = null;
                for (let t = 0; t < treeSelectData.length; t++) {
                    for (let i = 0; i < treeSelectData[t].children.length; i++) {
                        const child = treeSelectData[t].children[i];
                        if (child.key === key) {
                            topic = child;
                            break;
                        }
                    }
                }

                if (topic === null) {
                    resolve();
                    console.error('Error loading concepts for topic in wizard tree');
                    return;
                }

                axios.get('/web/ui/content/concept/conceptsWithSkills', {params: {topicId: topic.topicId}})
                    .then((response)=>{
                        // console.log('response.data: ',response.data);
                        if(response.data){
                            // console.log('response.data: ',response.data);
                            const concepts = [];
                            response.data.map( concept =>{
                                let conceptLabel = tabVal === TABS.TEXT.val ? concept.conceptName : concept.curriculumCode;
                                concepts.push(
                                    {
                                        key: key + '-' + concept.conceptId,
                                        selectable: false,
                                        checkable: true,
                                        value: key + '-' + concept.conceptId,
                                        conceptId: concept.conceptId,
                                        label: conceptLabel,
                                        title: conceptLabel,
                                        topicId: topic.topicId,
                                        isLeaf: false
                                    }
                                );
                            });
                            topic.children = concepts;
                            const updateData = [...treeSelectData];
                            if(TABS.TEXT.val === tabVal){
                                setTreeTextSelectData(updateData);
                            }else{
                                setTreeCurriculumSelectData(updateData);
                            }
                            // console.log('updateData: ',updateData);
                            resolve();
                        }
                    }).catch((error)=>{
                    resolve();
                    console.error('Error loading concepts for topic in tree: ',error);
                });
            }
        });

    // useEffect(()=>{
    // console.log('update treeTextSelectData: ', treeSelectData);
    // },[treeTextSelectData]);

    // useEffect(()=>{
    // console.log('update treeCurriculumSelectData: ', treeCurriculumSelectData);
    // },[treeCurriculumSelectData]);

    const onSelect = (selectedKeys, event) => {
        let tempSelectedSkillsMap = {},
            tempSelectedSkillIds = [],
            tempSelectedKeys = [];

        event.checkedNodes.map(node => {
            if (node.skillId) {
                if (tempSelectedSkillsMap[node.conceptId]) {
                    tempSelectedSkillsMap[node.conceptId] = [...tempSelectedSkillsMap[node.conceptId], node];
                } else {
                    tempSelectedSkillsMap[node.conceptId] = [node];
                    if (!tempSelectedKeys.includes(node.conceptName)) {
                        tempSelectedKeys.push(node.conceptName);
                    }
                }
                if (!tempSelectedSkillIds.includes(node.skillId)) {
                    tempSelectedSkillIds.push(node.skillId);
                }
            } else {
                if (tempSelectedSkillsMap[node.conceptId] === undefined) {
                    tempSelectedSkillsMap[node.conceptId] = [];
                }
                if (!tempSelectedKeys.includes(node.label)) {
                    tempSelectedKeys.push(node.label);
                }
            }
        });

        if (tabVal === TABS.TEXT.val) {
            setSelectedTextSkillsMap(tempSelectedSkillsMap);
            setSelectedTextSkillIds(tempSelectedSkillIds);
            setSelectedTextKeys(tempSelectedKeys);
        } else {
            setSelectedCurriculumSkillsMap(tempSelectedSkillsMap);
            setSelectedCurriculumSkillIds(tempSelectedSkillIds);
            setSelectedCurriculumKeys(tempSelectedKeys);
        }
    }

    // const updateTreeData = (list, key, children) =>
    //     list.map((node) => {
    //         if (node.key === key) {
    //             return {
    //                 ...node,
    //                 children,
    //             };
    //         }
    //         if (node.children) {
    //             return {
    //                 ...node,
    //                 children: updateTreeData(node.children, key, children),
    //             };
    //         }
    //         return node;
    //     });

    // const node = data.node;
    // console.log('key: ',key);
    // console.log('node: ',node);
    //     if(node.children || node.expanded){
    //         console.log('return');
    //         return;
    //     }

    const handleTabsChange = (val) => {
        setTabVal(val);
    }

    const changeQuestionAmount = (value) => {
        setQuestionAmount(value);
    }

    const updateTestName = (event)=>{
        // console.log('updateTestName: ',event.target.value);
        setTestName(event.target.value)
    }

    const updateDescription = (event)=>{
        setDescription(event.target.value)
    }

    return (
        <>
            <section className={'ch-diagnostics-pretest'}>
                <div id={'detailsFormWrapper'}>
                    <h3>Details</h3>
                    <Form
                        name={'testDetailsForm'}
                        form={updateDetailsForm}
                        initialValues={{testName: testName, description: description}}
                        layout="vertical"
                    >
                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item
                                    label="Name"
                                    name="testName"
                                    rules={[{required: true, message: 'Please input a name.',}]}
                                >
                                    <Input onChange={updateTestName} placeholder={'Name'}/>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Description"
                                    name="description"
                                >
                                    <Input.TextArea onChange={updateDescription} placeholder={'Description'}/>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </section>
            <section className={'ch-diagnostics-pretest'} style={{display: 'flex'}}>
                <div className="wizard-sub-cont size1of2">
                    {questionRatioTypes &&
                        <>
                            <h3>Questions</h3>
                            <p><span>Choose the question level breakdown for your test.</span><Tooltip placement={'top'} title={QUESTIONS_TOOLTIP}
                                // placement="bottom
                                arrowPointAtCenter>
                                <HelpIcon style={{
                                    verticalAlign: 'middle',
                                    marginLeft: '4px',
                                    width: '16px',
                                    height: '16px'
                                }}/>
                            </Tooltip></p>
                            <h4>Pick your difficulty ratio</h4>
                            <div id="difficultyOptionsWrapper">
                                <div onClick={() => {
                                    setRatioVal(questionRatioTypes.MOSTLY_EASY_SOME_MEDIUM)
                                }} className={ratioVal === questionRatioTypes.MOSTLY_EASY_SOME_MEDIUM ? "optionWrapper selected" : "optionWrapper"}>
                                    <div className="arcWrapper">
                                        <div className="arc-background"></div>
                                        <div className="easyLevelArc arc"></div>
                                    </div>
                                    <p className="textWrapper">
                                        <span>Mostly easy;</span>
                                        <span>some medium</span>
                                        <span>(3 : 1)</span>
                                    </p>
                                </div>
                                <div onClick={() => {
                                    setRatioVal(questionRatioTypes.ALL_MEDIUM)
                                }} className={ratioVal === questionRatioTypes.ALL_MEDIUM ? "optionWrapper selected" : "optionWrapper"}>
                                    <div className="arcWrapper">
                                        <div className="arc-background"></div>
                                        <div className="mediumLevelArc arc"></div>
                                    </div>
                                    <p className="textWrapper">
                                        <span>All medium</span>
                                    </p>
                                </div>
                                <div onClick={() => {
                                    setRatioVal(questionRatioTypes.BALANCED_MIX)
                                }} className={ratioVal === questionRatioTypes.BALANCED_MIX ? "optionWrapper selected" : "optionWrapper"}>
                                    <div className="arcWrapper">
                                        <div className="arc-background"></div>
                                        <div className="balancedLevelArc arc"></div>
                                    </div>
                                    <p className="textWrapper">
                                        <span>Balanced mix</span>
                                        <span>(1 : 2 : 1)</span>
                                    </p>
                                </div>
                                <div onClick={() => {
                                    setRatioVal(questionRatioTypes.MOSTLY_MEDIUM_SOME_HARD)
                                }} className={ratioVal === questionRatioTypes.MOSTLY_MEDIUM_SOME_HARD ? "optionWrapper selected" : "optionWrapper"}>
                                    <div className="arcWrapper">
                                        <div className="arc-background"></div>
                                        <div className="hardArc arc"></div>
                                    </div>
                                    <p className="textWrapper">
                                        <span>Mostly medium;</span>
                                        <span>some hard</span>
                                        <span>(3 : 1)</span>
                                    </p>
                                </div>
                            </div>
                            <div>
                                <p>A test must have at least <strong>{MIN_QUESTIONS}</strong> and not exceed <strong>{brandConfig.maxTestQuestions}</strong> questions.</p>
                                <span>Number of questions:</span> <InputNumber min={MIN_QUESTIONS} max={brandConfig.maxTestQuestions} defaultValue={defaultQuestionAmount}
                                                                               onChange={changeQuestionAmount}/>
                            </div>
                        </>
                    }
                    {/*<div id="generateSummary" className={'size3of5'}>*/}
                    {/*<h3>Summary</h3>*/}
                    {/*{questionRatioTypes && <div>*/}
                    {/*    <h4>Difficulty ratio</h4>*/}
                    {/*    <div>*/}
                    {/*        {questionRatioTypes.MOSTLY_EASY_SOME_MEDIUM === ratioVal && <div className="difficultySelectWrapper">*/}
                    {/*            <div className="arcWrapper">*/}
                    {/*                <div className="arc-b#ackground"></div>*/}
                    {/*                <div className="easyLevelArc arc"></div>*/}
                    {/*            </div>*/}
                    {/*            <p className="textWrapper">*/}
                    {/*                <span>Mostly easy; some medium (3 : 1)</span>*/}
                    {/*            </p>*/}
                    {/*        </div>}*/}
                    {/*        {questionRatioTypes.ALL_MEDIUM === ratioVal && <div className="difficultySelectWrapper">*/}
                    {/*            <div className="arcWrapper">*/}
                    {/*                <div className="arc-background"></div>*/}
                    {/*                <div className="mediumLevelArc arc"></div>*/}
                    {/*            </div>*/}
                    {/*            <p className="textWrapper">*/}
                    {/*                <span>All medium</span>*/}
                    {/*            </p>*/}
                    {/*        </div>}*/}
                    {/*        {questionRatioTypes.BALANCED_MIX === ratioVal && <div className="difficultySelectWrapper">*/}
                    {/*            <div className="arcWrapper">*/}
                    {/*                <div className="arc-background"></div>*/}
                    {/*                <div className="balancedLevelArc arc"></div>*/}
                    {/*            </div>*/}
                    {/*            <p className="textWrapper">*/}
                    {/*                <span>Balanced mix (1 : 2 : 1)</span>*/}
                    {/*            </p>*/}
                    {/*        </div>}*/}
                    {/*        {questionRatioTypes.MOSTLY_MEDIUM_SOME_HARD === ratioVal && <div className="difficultySelectWrapper">*/}
                    {/*            <div className="arcWrapper">*/}
                    {/*                <div className="arc-background"></div>*/}
                    {/*                <div className="hardArc arc"></div>*/}
                    {/*            </div>*/}
                    {/*            <p className="textWrapper">*/}
                    {/*                <span>Mostly medium; some hard (3 : 1)</span>*/}
                    {/*            </p>*/}
                    {/*        </div>}*/}
                    {/*    </div>*/}
                    {/*</div>}*/}
                    {/*{!questionRatioTypes &&*/}
                    {/*    <CircularLoader/>*/}
                    {/*}*/}
                    {/*<div>*/}
                    {/*    <h4>Question amount ({questionAmount})</h4>*/}
                    {/*</div>*/}
                    {/*<div>*/}
                    {/*    <h3>Course ({tabVal === TABS.TEXT.val ? TABS.TEXT.description : TABS.CURRICULUM.description })</h3>*/}
                    {/*    <h4>Selected {brandConfig.conceptsName.toLowerCase()} {tabVal === TABS.TEXT.val ? selectedTextKeys.length : selectedCurriculumKeys.length}</h4>*/}
                    {/*    <ul id="selectedConceptList">*/}
                    {/*        {tabVal === TABS.TEXT.val && selectedTextKeys.map(key => {*/}
                    {/*            return <li>{key}</li>*/}
                    {/*        })}*/}
                    {/*        {tabVal === TABS.CURRICULUM.val && selectedCurriculumKeys.map(key => {*/}
                    {/*            return <li>{key}</li>*/}
                    {/*        })}*/}
                    {/*    </ul>*/}
                    {/*</div>*/}
                    {/*{(tabVal === TABS.TEXT.val && selectedTextKeys.length > questionAmount) &&*/}
                    {/*    <span className="errorMessage">Selected {brandConfig.conceptsName.toLowerCase()} are more than question amount.</span>}*/}
                    {/*{(tabVal === TABS.CURRICULUM.val && selectedCurriculumKeys.length > questionAmount) &&*/}
                    {/*    <span className="errorMessage">Selected {brandConfig.conceptsName.toLowerCase()} are more than question amount.</span>}*/}
                    {/*{!testName && <span className="errorMessage">{brandConfig.testName} name required.</span>}*/}
                    {/*{description.trim() === '' && <span className="warningMessage">{brandConfig.testName} will be generated without a description.</span>}*/}
                    {/*<div>*/}
                    {/*    {tabVal === TABS.TEXT.val &&*/}
                    {/*        <Button disabled={selectedTextKeys.length === 0 || selectedTextKeys.length > questionAmount || !testName}*/}
                    {/*                onClick={generatePreTest} style={{height: '24px', alignSelf: 'end'}}>Generate</Button>}*/}
                    {/*    {tabVal === TABS.CURRICULUM.val &&*/}
                    {/*        <Button disabled={selectedCurriculumKeys.length === 0 || selectedCurriculumKeys.length > questionAmount || !testName}*/}
                    {/*                onClick={generatePreTest} style={{height: '24px', alignSelf: 'end'}}>Generate</Button>}*/}
                    {/*</div>*/}
                    {/*</div>*/}
                </div>
                <div id="diagnosticWizardTree" className="wizard-sub-cont size1of2">
                    <Tabs style={{marginTop: '16px'}}
                          size='middle'
                        // onTabClick={beforeTabChange}
                          onChange={handleTabsChange}
                          id={'diagnosticWizardTreeTabs'}
                          variant="standard">
                        <Tab id={'diagnosticWizardTab' + TABS.TEXT.description} key={TABS.TEXT.val} tab={TABS.TEXT.description} children={
                            <Tree onCheck={onSelect} multiple={true} style={{width: '100%'}} treeData={treeTextSelectData} checkable={true}
                                  height={treeMaxHeight}
                                  // onLoad={onNodeLoad}
                                  loadData={loadData}
                                  virtual={false}
                                  defaultExpandedKeys={textTreeDefaultExpandedKeys}
                                  titleRender={(nodeData) => {
                                      return (<div id={nodeData.key}>
                                          <MathJaxHTMLContent html={nodeData.title}/>
                                      </div>);
                                  }}
                            />
                        } value={TABS.TEXT.val}/>
                        {(curriculumSyllabus && Object.keys(curriculumSyllabus).length > 0) &&
                            <Tab id={'diagnosticWizardTab' + TABS.CURRICULUM.description} key={TABS.CURRICULUM.val} tab={TABS.CURRICULUM.description} children={
                                <Tree onCheck={onSelect} multiple={true} style={{width: '100%'}} treeData={treeCurriculumSelectData} checkable={true}
                                      height={treeMaxHeight}
                                      // onLoad={onNodeLoad}
                                      loadData={loadData}
                                      virtual={false}
                                      titleRender={(nodeData) => {
                                          return (<div id={nodeData.key}>
                                              <MathJaxHTMLContent html={nodeData.title}/>
                                          </div>);
                                      }}
                                />}
                                 value={TABS.CURRICULUM.val}/>}
                    </Tabs>
                    <div id={'wizardGenerateCont'}>
                        {((tabVal === TABS.TEXT.val && selectedTextKeys.length > questionAmount) || (tabVal === TABS.CURRICULUM.val && selectedCurriculumKeys.length > questionAmount)) &&
                            <span className="errorMessage">Selected {brandConfig.conceptsName.toLowerCase()} are more than question amount.</span>
                        }
                        {!testName && <span className="errorMessage">{brandConfig.diagnosticName} name required.</span>}
                        {description.trim() === '' &&
                            <span className="warningMessage">{brandConfig.diagnosticName} will be generated without a description.</span>}
                        <div>
                            <Button
                                disabled={(tabVal === TABS.TEXT.val && (selectedTextKeys.length === 0 || selectedTextKeys.length > questionAmount || !testName))
                                    || tabVal === TABS.CURRICULUM.val && (selectedCurriculumKeys.length === 0 || selectedCurriculumKeys.length > questionAmount || !testName)}
                                onClick={generatePreTest} style={{height: '24px', alignSelf: 'end'}}>Generate</Button>
                        </div>
                    </div>
                </div>
            </section>
            {!questionRatioTypes &&
                <div style={{padding: '8px'}}><CircularLoader/></div>
            }
        </>
    )
}
export default PreTest;
